var map = {
	"./cafes-icon.svg": "78c4",
	"./gyms-icon.svg": "38eb",
	"./home-icon.svg": "7570",
	"./metro-icon.svg": "446a",
	"./parking-icon.svg": "c11a",
	"./shops-icon.svg": "5a74"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8b63";